(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["qf-cart-fast"] && !Shopify.designMode) return;
  try {
    (function () {
  let installed = false;
  function install() {
    if (installed || !window.vm || !window.QFCart) return;
    installed = true;
    const api = window.QFCart;
    api.seed(api.snapshot());
    let resuming = false, waiting = false;
    async function finish(resume) {
      if (waiting) return;
      waiting = true;
      try {
        // Flush quantities first: a rejected quantity must not be hidden by a subsequent attribute save.
        await api.flush();
        if (window.qfcSaveAttributes) await window.qfcSaveAttributes(null, true);
        await api.flush();
        resuming = true; resume();
      } catch (error) { /* Shared bilingual error remains visible. Never retry an uncertain write. */ }
      finally { resuming = false; waiting = false; }
    }
    document.addEventListener('click', event => {
      const button = event.target.closest('[name="checkout"],a[href$="/checkout"]');
      if (!button || resuming) return;
      event.preventDefault(); event.stopImmediatePropagation();
      void finish(() => button.click());
    }, true);
    document.addEventListener('submit', event => {
      if (resuming || !event.target.matches('form[action$="/checkout"]')) return;
      event.preventDefault(); event.stopImmediatePropagation();
      const form = event.target, submitter = event.submitter;
      void finish(() => form.requestSubmit(submitter || undefined));
    }, true);
  }
  document.addEventListener('qfc:ready', install);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', install); else install();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qf-mobile-drawer"] && !Shopify.designMode) return;
  try {
    (function(){
function init(){
var dialog=document.getElementById('qfd-mobile-drawer'),trigger=document.querySelector('#shopify-section-header #nav-toggle');
if(!dialog||!trigger||dialog.dataset.ready)return;
dialog.dataset.ready='true';trigger.setAttribute('aria-controls',dialog.id);trigger.setAttribute('aria-expanded','false');
function close(){if(dialog.open)dialog.close();}
document.addEventListener('click',function(event){
if(event.target.closest('#shopify-section-header #nav-toggle')){
event.preventDefault();event.stopImmediatePropagation();
if(dialog.open){close();return;}
dialog.showModal();document.documentElement.classList.add('qfd-menu-open');trigger.setAttribute('aria-expanded','true');
}
},true);
dialog.addEventListener('click',function(event){
if(event.target.closest('[data-qfd-drawer-close]')||event.target.closest('a'))close();
if(event.target===dialog){var rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close();}
});
dialog.addEventListener('close',function(){document.documentElement.classList.remove('qfd-menu-open');trigger.setAttribute('aria-expanded','false');trigger.focus({preventScroll:true});});
dialog.querySelectorAll('details').forEach(function(item){item.addEventListener('toggle',function(){if(item.open)dialog.querySelectorAll('details[open]').forEach(function(other){if(other!==item)other.open=false;});});});
window.matchMedia('(min-width:769px)').addEventListener('change',function(event){if(event.matches)close();});
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qf-purchase-controller"] && !Shopify.designMode) return;
  try {
    (() => {
  const config = document.getElementById('qfp-config');
  if (!config || config.dataset.ready) return;
  config.dataset.ready = 'true';
  const t = config.dataset;
  const ar = JSON.parse(document.getElementById('qfp-ar-config').textContent);
  const arKey = {error:'load_error',requestError:'request_error',subscriptionAdded:'subscription_added',addSub:'add_subscription',soldOut:'sold_out',deliveryTotal:'delivery_total',choose:'choose_short',quantityError:'quantity_error',bulkCard:'bulk_card',bulkSaving:'bulk_saving',bulkNudge:'bulk_nudge',bulkTerms:'bulk_terms',noStack:'no_stack',weight:'weight_total'};
  const formatCopy = (value, values = {}) => Object.entries(values).reduce((text,[key,replacement]) => text.replaceAll('['+key+']','\u2068'+replacement+'\u2069'),value || '');
  const setCopy = (element,key,values = {}) => {
    const wrap=document.createElement('span');wrap.className='qfp-copy';
    for(const [lang,text] of [['en',t[key]],['ar',ar[arKey[key] || key]]]) {
      if(!text)continue;
      const span=document.createElement('span');span.className='qfp-'+lang;span.lang=lang;span.dir=lang==='ar'?'rtl':'ltr';span.textContent=formatCopy(text,values);wrap.append(span);
    }
    element.replaceChildren(wrap);
  };
  const optionLabel = key => t[key]+' / \u2067'+ar[arKey[key] || key]+'\u2069';
  const planLabel = name => {
    const match=name.match(/^(?:delivery\s+)?every\s+(\d+)\s+(day|week|month|year)s?(?:\s+with\s+\d+(?:\.\d+)?%\s+discount)?\.?$/i);
    if(!match)return name;
    const count=Number(match[1]);
    if(!Number.isInteger(count)||count<1)return name;
    const form=count===1?'one':count===2?'two':count%100>=3&&count%100<=10?'few':'other';
    const shortName=name.replace(/^delivery\s+/i,'').replace(/\s+with\s+\d+(?:\.\d+)?%\s+discount\.?$/i,'');
    return shortName+' / \u2067'+formatCopy(ar[match[2].toLowerCase()+'_'+form],{count})+'\u2069';
  };
  let bulk = {enabled:false};
  try { bulk = JSON.parse(document.getElementById('qfp-bulk-config').textContent); } catch(error) { bulk = {enabled:false}; }
  const bulkUnitPrice = (qty,regularPrice) => (bulk.tiers || []).reduce((price,tier) => qty >= tier.quantity && Number.isInteger(tier.unitPrice) && tier.unitPrice >= 0 ? Math.min(price,tier.unitPrice) : price,regularPrice);
  const highestBulkQuantity = Math.max(1,...(bulk.tiers || []).map(tier => Number(tier.quantity) || 1));
  const dialog = document.getElementById('qfp-dialog');
  const body = dialog.querySelector('[data-qfp-body]');
  const root = t.root || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:t.currency,currencyDisplay:'code'}).format(cents / 100);
  let lastTrigger;
  let requestId = 0;
  // Cart writes and refreshes are coordinated by QFCart.
  const confirmation = document.getElementById('qfp-confirmation');
  let confirmationTimer;
  let confirmationTrigger;
  const hideConfirmation = (restoreFocus = false) => {
    clearTimeout(confirmationTimer);
    confirmation.hidden=true;
    if(restoreFocus && confirmationTrigger && confirmationTrigger.isConnected)confirmationTrigger.focus({preventScroll:true});
  };
  const scheduleDismiss = () => {
    clearTimeout(confirmationTimer);
    if(confirmation.matches(':hover') || confirmation.contains(document.activeElement))return;
    confirmationTimer=setTimeout(()=>hideConfirmation(),10000);
  };
  const showConfirmation = (panel,item,title) => {
    confirmationTrigger=dialog.contains(panel)?lastTrigger:panel.querySelector('[data-qfp-submit]');
    if(dialog.contains(panel) && dialog.open)dialog.close();
    confirmation.hidden=false;
    setCopy(confirmation.querySelector('[data-qfp-confirmation-message]'),item.selling_plan?'subscriptionAdded':'added');
    confirmation.querySelector('[data-qfp-confirmation-product]').textContent=item.quantity+' × '+title;
    scheduleDismiss();
  };
  confirmation.querySelector('[data-qfp-dismiss]').addEventListener('click',()=>hideConfirmation(true));
  confirmation.querySelector('[data-qfp-continue]').addEventListener('click',()=>hideConfirmation(true));
  confirmation.addEventListener('pointerenter',()=>clearTimeout(confirmationTimer));
  confirmation.addEventListener('focusin',()=>clearTimeout(confirmationTimer));
  confirmation.addEventListener('pointerleave',scheduleDismiss);
  confirmation.addEventListener('focusout',()=>setTimeout(scheduleDismiss,0));
  // No independent cart read may overwrite a newer quantity or subscription update.
  const eligible = () => t.collection === 'subscribe-save';
  const enhance = () => {
    document.querySelectorAll('li.snize-product').forEach(card => {
      if (!eligible(card) || card.querySelector('.qfp-card-button') || !card.classList.contains('snize-product-in-stock')) return;
      const link = card.querySelector('a.snize-view-link');
      if (!link) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'qfp-card-button'; setCopy(button,'options');
      button.setAttribute('aria-haspopup','dialog'); button.setAttribute('aria-label',optionLabel('options') + ': ' + (link.getAttribute('aria-label') || link.textContent.trim()));
      button.dataset.qfpUrl = link.getAttribute('href');
      if (bulk.enabled && card.dataset.originalProductId === bulk.productId) {
        const offer = document.createElement('p'); offer.className='qfp-card-offer'; setCopy(offer,'bulkCard'); card.append(offer);
      }
      card.append(button); card.classList.add('qfp-card');
      const legacyControl = card.querySelector('.grid-view-item__price-qty');
      if (legacyControl) legacyControl.remove();
    });
  };
  function initialise(panel) {
    if (panel.dataset.ready) return;
    panel.dataset.ready = 'true';
    const data = JSON.parse(panel.querySelector('[data-qfp-data]').textContent);
    const form = panel.querySelector('form');
    const variantInput = form.querySelector('[data-qfp-variant]');
    const planInput = form.querySelector('[data-qfp-plan]');
    const quantity = form.querySelector('[data-qfp-quantity]');
    const once = form.querySelector('[value="once"]');
    const subscription = form.querySelector('[value="subscribe"]');
    const submit = form.querySelector('[data-qfp-submit]');
    const status = form.querySelector('[data-qfp-status]');
    let variant;
    let plans = [];
    let uncertain = false;
    let pending = false;
    const display = () => {
      const selected = plans.find(p => String(p.id) === planInput.value);
      const recurring = subscription.checked;
      const qty = Number(quantity.value);
      const validQty = Number.isInteger(qty) && qty > 0;
      const hasBulk = bulk.enabled && String(variant.id) === bulk.variantId;
      const oncePrice = hasBulk && !recurring && validQty ? bulkUnitPrice(qty,variant.price) : variant.price;
      const chosenPrice = recurring && selected ? selected.price : oncePrice;
      panel.classList.toggle('qfp-has-bulk',hasBulk);
      const tiers = panel.querySelector('[data-qfp-bulk]');
      if (tiers) tiers.hidden = !hasBulk || recurring;
      const saving = panel.querySelector('[data-qfp-bulk-saving]');
      saving.hidden = !hasBulk || recurring || !validQty;
      setCopy(saving,oncePrice < variant.price ? 'bulkSaving' : 'bulkNudge',{amount:money((variant.price-oncePrice)*qty)});
      const terms = panel.querySelector('[data-qfp-bulk-terms]');
      terms.hidden = !hasBulk;
      setCopy(terms,recurring ? 'noStack' : 'bulkTerms');
      const weight = panel.querySelector('[data-qfp-weight]');
      if (weight) { if(validQty)setCopy(weight,'weight',{weight:String(Math.round(qty*32)/10)});else weight.textContent=''; }
      panel.querySelector('[data-qfp-frequency-wrap]').hidden = !recurring;
      panel.querySelector('[data-qfp-recurring]').hidden = !recurring;
      planInput.disabled = !recurring;
      planInput.required = recurring;
      setCopy(panel.querySelector('[data-qfp-total-label]'),recurring ? 'deliveryTotal' : 'total');
      panel.querySelector('[data-qfp-total]').textContent = recurring && !selected ? '—' : money(chosenPrice * (validQty ? qty : 1));
      submit.disabled = pending || uncertain || !variant.available || !validQty || (recurring && !selected);
      setCopy(submit,!variant.available ? 'soldOut' : (recurring ? 'addSub' : 'add'));
      panel.querySelectorAll('[data-qfp-qty]').forEach(button => {
        const amount=Number(button.dataset.qfpQty);
        button.setAttribute('aria-pressed',String(amount === (qty>=highestBulkQuantity?highestBulkQuantity:qty)));
        const price=button.querySelector('[data-qfp-tier-price]');
        if(price)price.textContent=money(hasBulk ? bulkUnitPrice(amount,variant.price) : variant.price);
      });
      if (selected) {
        panel.querySelector('[data-qfp-sub-price]').textContent = money(selected.price);
        const saving = Math.max(0,Math.round((1 - selected.price / variant.price) * 100));
        if(saving)setCopy(panel.querySelector('[data-qfp-saving]'),'save',{percent:saving});else panel.querySelector('[data-qfp-saving]').textContent=planLabel(selected.name);
      }
    };
    const changeVariant = () => {
      variant = data.variants.find(v => String(v.id) === variantInput.value);
      if (!variant) { submit.disabled = true; return; }
      plans = variant.plans.filter(p => p.recurring && p.price === p.perDelivery && p.price === p.checkoutCharge);
      planInput.replaceChildren(new Option(optionLabel('choose'),''));
      plans.forEach(plan => {const option=new Option(planLabel(plan.name),String(plan.id));option.title=plan.name;planInput.add(option);});
      panel.querySelector('[data-qfp-once-price]').textContent = money(variant.price);
      panel.querySelector('[data-qfp-once-option]').hidden = variant.requiresPlan;
      once.disabled = variant.requiresPlan;
      panel.querySelector('[data-qfp-sub-option]').hidden = !plans.length;
      subscription.disabled = !plans.length;
      once.checked = !variant.requiresPlan; subscription.checked = variant.requiresPlan;
      if (plans.length) {
        const first = plans[0];
        panel.querySelector('[data-qfp-sub-price]').textContent = money(first.price);
        const saving = Math.max(0,Math.round((1-first.price / variant.price)*100));
        if(saving)setCopy(panel.querySelector('[data-qfp-saving]'),'save',{percent:saving});else panel.querySelector('[data-qfp-saving]').textContent=planLabel(first.name);
      }
      display();
    };
    variantInput.addEventListener('change',changeVariant);
    form.addEventListener('change',display);
    quantity.addEventListener('input',display);
    form.querySelectorAll('[data-qfp-qty]').forEach(button => button.addEventListener('click',() => {quantity.value=button.dataset.qfpQty;display();}));
    form.addEventListener('submit',async event => {
      event.preventDefault(); event.stopImmediatePropagation();
      if (pending || uncertain || !form.reportValidity() || submit.disabled) return;
      const qty = Number(quantity.value);
      if (!Number.isInteger(qty) || qty < 1) { setCopy(status,'quantityError');return; }
      const item = {id:variant.id,quantity:qty};
      if (subscription.checked) {
        const plan = plans.find(p => String(p.id) === planInput.value);
        if (!plan) return;
        item.selling_plan = plan.id;
      }
      if (!window.QFCart) {setCopy(status,'error');return;}
      pending = true; submit.disabled = true; setCopy(submit,'adding'); status.textContent='';
      let added = false;
      try {
        const result = await window.QFCart.add([item]);
        const confirmed=Array.isArray(result.items) && result.items.some(addedItem=>String(addedItem.id)===String(item.id) && Number(addedItem.quantity)>=qty && (!item.selling_plan || String(addedItem.selling_plan_allocation && addedItem.selling_plan_allocation.selling_plan.id)===String(item.selling_plan)));
        if(!confirmed)throw new Error('Missing confirmed item');
        added = true;
        setCopy(status,'added');
        form.querySelector('[data-qfp-basket]').hidden=false;
        showConfirmation(panel,item,data.title);
      } catch(error) {
        if (error.status >= 400 && error.status < 500) {
          setCopy(status,'requestError');
          const detail=document.createElement('span');detail.className='qfp-request-detail';detail.dir='auto';detail.textContent=error.message;status.append(detail);
        } else if (!added) {uncertain=true;setCopy(status,'uncertain');}
        form.querySelector('[data-qfp-basket]').hidden=false;
      } finally {
        pending=false;display();
      }
    });
    changeVariant();
  }
  const optionCache = new Map();
  function loadOptions(button) {
    const url = new URL(button.dataset.qfpUrl, location.origin);
    if (url.origin !== location.origin) return Promise.reject(new Error('Invalid product URL'));
    url.searchParams.set('section_id','qf-purchase-data');
    const key = url.toString(), cached = optionCache.get(key);
    if (cached && Date.now() - cached.time < 60000) return cached.promise;
    const promise = fetch(url,{headers:{Accept:'text/html'}}).then(response => {
      if (!response.ok) throw new Error('Product options unavailable');
      return response.text();
    }).catch(error => { optionCache.delete(key); throw error; });
    optionCache.set(key,{time:Date.now(),promise});
    if (optionCache.size > 12) optionCache.delete(optionCache.keys().next().value);
    return promise;
  }
  async function openOptions(button) {
    hideConfirmation();
    const id = ++requestId;
    lastTrigger=button;
    body.replaceChildren();
    const loading=document.createElement('p');loading.className='qfp-loading';setCopy(loading,'loading');body.append(loading);
    dialog.showModal();
    try {
      const html=await loadOptions(button);
      const template=new DOMParser().parseFromString(html,'text/html').querySelector('template[data-qfp-content]');
      const panel=template && template.content.querySelector('[data-qfp-panel]');
      if(!panel)throw new Error('Missing product options');
      if(id!==requestId||!dialog.open)return;
      body.replaceChildren(document.importNode(panel,true));initialise(body.querySelector('[data-qfp-panel]'));
    }catch(error){
      if(id!==requestId||!dialog.open)return;
      const message=document.createElement('div');message.className='qfp-error';setCopy(message,'error');
      const link=document.createElement('a');link.href=button.dataset.qfpUrl;setCopy(link,'options');message.append(link);body.replaceChildren(message);
    }
  }
  dialog.querySelector('[data-qfp-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{requestId++;if(lastTrigger&&lastTrigger.isConnected)lastTrigger.focus({preventScroll:true});});
  document.addEventListener('click',event=>{const button=event.target.closest('[data-qfp-url]');if(button){event.preventDefault();event.stopPropagation();openOptions(button);}},true);
  const warmOptions = event => { const button = event.target.closest('[data-qfp-url]'); if (button) void loadOptions(button).catch(() => {}); };
  document.addEventListener('pointerover',warmOptions,{passive:true});
  document.addEventListener('focusin',warmOptions);
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;enhance();});};
  const boot=()=>{
    document.querySelectorAll('[data-qfp-panel]').forEach(initialise);enhance();
    if(t.collection !== 'subscribe-save')return;
    const target=document.getElementById('MainContent');
    if(target)new MutationObserver(changes=>{if(changes.some(change=>[...change.addedNodes].some(node=>node.nodeType===1&&(node.matches('li.snize-product')||node.querySelector('li.snize-product')))))schedule();}).observe(target,{childList:true,subtree:true});
    if(window.jQuery)window.jQuery(document).on('Searchanise.ResultsUpdated Searchanise.Loaded',schedule);
    document.addEventListener('Searchanise.ResultsUpdated',schedule);
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot);else boot();
})();
  } catch(e) { console.error(e); }
})();

})();
